const PRESENCE_TAB_KEY = "neptune.presence.tab-id";

const generateTabId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `tab-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

export const getPresenceTabId = () => {
  if (typeof window === "undefined") {
    return "server";
  }

  const existing = window.sessionStorage.getItem(PRESENCE_TAB_KEY);
  if (existing) {
    return existing;
  }

  const nextValue = generateTabId();
  window.sessionStorage.setItem(PRESENCE_TAB_KEY, nextValue);
  return nextValue;
};
